module.exports = __webpack_public_path__ + "static/media/play.c52a3217.svg";